import { render } from "./UserRoleBadge.vue?vue&type=template&id=580db7b2"
import script from "./UserRoleBadge.vue?vue&type=script&lang=js"
export * from "./UserRoleBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__